// Core
import Vue from "vue";
import Vuex from "vuex";
import VueRouter from "vue-router";
import VueFormulate from "@braid/vue-formulate";
import axios from "axios";
import VueAxios from "vue-axios";
import VueImg from 'v-img';
import JsonCSV from 'vue-json-csv';
import VModal from 'vue-js-modal';
import VueGoodTablePlugin from 'vue-good-table';
import VueLoading from 'vuejs-loading-plugin';
import VueMeta from 'vue-meta';
import middleware from "@grafikri/vue-middleware"

// Styles
import "@fortawesome/fontawesome-free/css/all.min.css";
import "@/assets/styles/tailwind.css";
import "@/assets/styles/formulate.css";
import "vue-inner-image-zoom/lib/vue-inner-image-zoom.css";
import "vue-good-table/dist/vue-good-table.css";

// Mounting point for the whole app
import App from "@/App.vue";

// Vuex store
import store from "./store";

// Layouts
import Admin from "@/layouts/Admin.vue";
import Auth from "@/layouts/Auth.vue";

// Admin
import Dashboard from "@/views/admin/Dashboard.vue";
import Users from "@/views/admin/Users.vue";
import Chart from "@/views/admin/Chart.vue";
import DynamicChart from "@/views/admin/DynamicChart.vue";
import Incidents from "@/views/admin/Incidents.vue";
import MyIncidents from "@/views/admin/MyIncidents.vue";
import Teams from "@/views/admin/Teams.vue";
import Team from "@/views/admin/Team.vue";
import MyTeams from "@/views/admin/MyTeams.vue";
import MyTeam from "@/views/admin/MyTeam.vue";
import Roles from "@/views/admin/Roles.vue";

// Employee Self Service
import Login from "@/views/auth/Login.vue";
import Register from "@/views/auth/Register.vue";

// Guest
import Landing from "@/views/Landing.vue";

// Middleware
import ess from "./middleware/ess";
import manager_chart from "./middleware/manager_chart";
import manager_table from "./middleware/manager_table";

// Routes
const routes = [
  {
    path: "/admin",
    redirect: "/admin/dashboard",
    component: Admin,
    children: [
      {
        path: "/admin/dashboard",
        component: Dashboard,
        name: "Dashboard",
      },
      {
        path: "/admin/incidents",
        component: Incidents,
        name: "Incidents",
        meta: {
          middleware: [
            ess,
            manager_chart,
            manager_table
          ]
        },
      },
      {
        path: "/admin/teams",
        component: Teams,
        name: "Teams",
        meta: {
          middleware: [
            ess,
            manager_chart,
            manager_table
          ]
        },
      },
      {
        path: "/admin/teams/:id",
        name: "Team",
        component: Team,
        props: true,
        meta: {
          middleware: [
            ess,
            manager_chart,
            manager_table
          ]
        },
      },
      {
        path: "/admin/roles",
        component: Roles,
        name: "Roles",
        meta: {
          middleware: [
            ess,
            manager_chart,
            manager_table
          ]
        },
      },
      {
        path: "/admin/users",
        component: Users,
        name: "Users",
        meta: {
          middleware: [
            ess,
            manager_chart,
            manager_table
          ]
        },
      },
      {
        path: "/admin/chart",
        name: "Charts",
        component: Chart,
        props: true,
        meta: {
          middleware: [
            ess,
          ]
        },
      },
      {
        path: "/admin/chart/:id",
        name: "Chart",
        component: Chart,
        props: true,
        meta: {
          middleware: [
            ess,
          ]
        },
      },
      {
        path: "/admin/chart/:id/:chart",
        name: "Dynamic Chart",
        component: DynamicChart,
        props: true,
        meta: {
          middleware: [
            ess,
          ]
        },
      },
      {
        path: "/user/:id/incidents",
        component: MyIncidents,
        name: "My Incidents"
      },
      {
        path: "/user/:id/teams",
        component: MyTeams,
        name: "My Teams"
      },
      {
        path: "/user/:id/teams/:id",
        name: "My Team",
        component: MyTeam,
        props: true,
      },
      {
        path: "/user/:id/dashboard",
        component: Dashboard,
        name: "Dashboard"
      },
    ],
    beforeEnter: ifAuthenticated,
  },
  {
    path: "/auth",
    redirect: "/auth/login",
    component: Auth,
    children: [
      {
        path: "/auth/login",
        component: Login,
        name: "Sign In",
      },
      {
        path: "/auth/register",
        component: Register,
        name: "Sign Up",
      },
    ],
  },
  {
    path: "/",
    name: "Home",
    component: Landing,
  },
  { path: "*", redirect: "/" },
];

const ifAuthenticated = (next) => {
  const loggedIn = localStorage.getItem("user");
  if (!loggedIn) {
    next("/auth/login");
  } else {
    next();
  }
};

axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';

Vue.prototype.$appName = 'Atlas Service Management';
Vue.prototype.$log = console.log;

Vue.use(VueRouter);
Vue.use(Vuex);
Vue.use(VueFormulate);
Vue.use(VueAxios, axios);
Vue.use(VueImg);
Vue.use(VueLoading);
Vue.use(require('vue-moment'));
Vue.component('downloadCsv', JsonCSV);
Vue.use(VModal, { dialog: true });
Vue.use(VueGoodTablePlugin);
Vue.use(VueMeta, { refreshOnceOnNavigation: true });

const router = new VueRouter({
  mode: "history",
  routes,
});

router.beforeEach(middleware({ store }));

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");